// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"238":"cea87192","239":"a1222705","453":"203924f0","455":"223bf7ce","977":"3812c3fc"}[chunkId] + ".chunk.js";
};